export default __webpack_public_path__ + "5a6013ddcfb9f2d6d9bbed3e46a7c178.svg";